import script from "./ApplicationList.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationList.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationList.vue?vue&type=style&index=0&id=53079b78&lang=css"

const __exports__ = script;

export default __exports__